import { cartPageContainerStyles } from "@insite/content-library/Widgets/Cart/CartPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

cartPageContainerStyles.headerContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        border-width: 0;
                    `,
                    null,
                    css``,
                ],
                "min",
            )}
    `,
};
